var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact"},[_c('TitlePage'),_c('CommonTitle',{attrs:{"text":_vm.text,"cont":_vm.cont}}),_c('div',{staticClass:"contact-cont"},[_c('div',{staticClass:"contL",domProps:{"innerHTML":_vm._s(_vm.content.content)}}),(_vm.fullWidth > 900)?_c('div',{staticClass:"contR"},[_c('User')],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }